import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private apiCount = 0;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  /** Uma tela assumiu o loader e o exibe na própria área de conteúdo. */
  private escopoInlineSubject = new BehaviorSubject<boolean>(false);

  /**
   * Carregamento que o overlay de página inteira deve mostrar. Enquanto alguma
   * tela assume o loader — via `assumirLoaderInline` —, ela exibe o indicador
   * dentro do seu próprio container e o overlay fica de fora.
   */
  isLoadingOverlay$ = combineLatest([
    this.isLoadingSubject,
    this.escopoInlineSubject,
  ]).pipe(map(([carregando, inline]) => carregando && !inline));

  constructor() { }

  /** A partir daqui o carregamento é exibido pela tela, não pelo overlay. */
  assumirLoaderInline() {
    this.escopoInlineSubject.next(true);
  }

  /** Devolve o carregamento ao overlay de página inteira. */
  liberarLoaderInline() {
    this.escopoInlineSubject.next(false);
  }

  showLoader() {
    if (this.apiCount === 0) {
      this.isLoadingSubject.next(true);
    }
    this.apiCount++;
  }

  hideLoader() {
    if (this.apiCount > 0) {
      this.apiCount--;
    }
    if (this.apiCount === 0) {
      this.isLoadingSubject.next(false);
    }
  }
}
